<template>
  <v-row>
    <v-col
      cols="12"
      lg="6"
      sm="6"
      v-for="card in cards"
      :visitInfo="visitInfo"
      :key="card.title"
      class="py-0 mb-3"
    >
      <v-card outlined class="elevation-0">
        <v-card-text class="pa-3">
          <div class="d-flex align-center">
            <v-btn :class="[card.iconcolor]" class="elevation-0" fab dark small>
              <v-icon small>{{ card.icon }}</v-icon>
            </v-btn>
            <div class="ml-5 mr-1">
              <h2 class="title font-weight-light">
                {{ card.number }}
              </h2>
              <h5 class="caption font-weight-regular">
                {{ card.title }}
              </h5>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "VisitInfo",
  props: ["visitInfo"],
  data: () => ({
    isLoading: false,
    cards: [
      {
        title: "Total Visitors",
        iconcolor: "info",
        icon: "mdi-account-multiple",
        number: "0"
      },
      {
        title: "Unique Visitors",
        iconcolor: "warning",
        icon: "mdi-account",
        number: "0"
      },
      {
        title: "Total Spent Time",
        iconcolor: "deep-purple accent-2",
        icon: "mdi-timer-sand",
        number: "0"
      },
      {
        title: "Average Spent Time ",
        iconcolor: "error",
        icon: "mdi-camera-timer",
        number: "0"
      }
    ]
  }),
  watch: {
    visitInfo(newVal) {
      if (newVal) {
        this.cards[0].number = this.visitInfo.visitorsCount;
        this.cards[1].number = this.visitInfo.netVisitorsCount;
        this.cards[2].number = this.showTime(this.visitInfo.spentTime);
        this.cards[3].number = this.showTime(this.visitInfo.averageSpentTime);
      }
    }
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    showTime(min) {
      const hrStr = min < 60 ? 0 : parseInt(min / 60);
      const minStr = min % 60;
      if (hrStr == 0) {
        return `${minStr}min`;
      } else {
        if (minStr == 0) {
          return `${hrStr}hr`;
        } else {
          return `${hrStr}hr ${minStr}min`;
        }
      }
    }
  }
};
</script>
